import { useDispatch, useSelector } from "react-redux";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import { componentKey, setCheckForStateFrequencyPopup, setPaginationState, setSelectedPayer, setSelectedReconciliationResubmitGridData, setSelectedStateWitheldPaymentFrequency, setShowStateWitheldPaymentFrequencyPopup } from "./ReconciliationResubmitSlice";
import Loadable from "../../../../components/loadable/Loadable";
import commonStyles from "../../FormSection.styles"
import { QUERY_PARAMS } from "../../constants";
import RichGrid from "../../../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Label from "../../../../components/label/Label";
import Button from "../../../../components/button/Button";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import { getPayersList, getReconFrequencyPopUpOption, getReconciliationResubmitGridData, resubmitRecon, viewReconciliationPDF } from "./ReconciliationResubmitSaga";
import { useEffect, useState } from "react";
import Payer from "../.././../../../libs/utility/Payer"
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import ReconciliationFormSubmitPopup from "../../../components/reconciliationformsubmitpopup/ReconciliationFormSubmitPopup";
import Popup from "../../../../components/popup/Popup";
import { FREQUENCY_POPUP_HEADER, SELECT_PAYMENT_FREQUENCY } from "../../reconciliation/constants";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import RadioInput from "../../../../components/input/radioinput/RadioInput";
import useFormatTIN from "../../../../../libs/customhooks/useFormatTIN";
import { RECONCILIATION_RESUBMIT_LOADING_STATES, RECONCILIATION_RESUBMIT_MESSAGE_MAP } from "../constant";

export default function ReconciliationResubmitForms() {

    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const [isReconciliationFormSubmitPopupOpen, setIsReconciliationFormSubmitPopupOpen] = useState(false);
    const [selectedRowForReconciliation, setSelectedRowForReconciliation] = useState(null);
    const { loadingState, payerList, selectedPayer, reconciliationResubmitGridData, selectedReconciliationResubmitGridData, paginationState, stateWitheldPaymentFrequency, showStateWitheldPaymentFrequencyPopup, checkForStateFrequencyPopup, selectedStateWitheldPaymentFrequency } = useSelector(state => state[componentKey]);

    const { formatTIN } = useFormatTIN()

    useEffect(() => {
        dispatch(getPayersList());
    }, []);

    useEffect(() => {
        if (selectedPayer?.value) {
            dispatch(getReconciliationResubmitGridData({ payerId: selectedPayer?.value, ...paginationState }))
        }
    }, [selectedPayer, paginationState.PageNumber, paginationState.PageSize,])

    useEffect(() => {
        if(checkForStateFrequencyPopup){
            if(stateWitheldPaymentFrequency[selectedRowForReconciliation?.ReconFormType]) {
                dispatch(setShowStateWitheldPaymentFrequencyPopup(true));
            } else {
                setIsReconciliationFormSubmitPopupOpen(true);
            }
            dispatch(setCheckForStateFrequencyPopup(false));
        }
    }, [checkForStateFrequencyPopup]);

    const handleEditReconciliationBtnClk = (row) => {
        setSelectedRowForReconciliation(row);
        dispatch(getReconFrequencyPopUpOption({
            state: row?.State,
            reconFormid: row?.FormRecordId,
        }))
    }

    const RECONCILIATION_RESUBMIT_FORMS_COLUMN = [
        {
            field: "ReferenceNumber",
            header: <Label weight={LABEL_WEIGHT[700]}>Reference No</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.ReferenceNumber || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.TIN) || "-"}</span>
        },
        {
            field: "TaxYear",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax Year</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.TaxYear || "-"}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>State</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.State || "-"}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.FormShortName || "-"}</span>
        },
        {
            field: "Reason",
            header: <Label weight={LABEL_WEIGHT[700]}>Rejection Reason</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Reason || "-"}</span>
        },
        {
            field: "StateWithheld1",
            header: <Label weight={LABEL_WEIGHT[700]}>State Withheld ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.AccountNumber || "-"}</span>
        },
        {
            field: "Action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => <div style={commonStyles.actionButtons}>
                <Button onClickCb={() => handleEditReconciliationBtnClk(row)}>Update Withheld ID</Button>
                
                <Loadable currentState={loadingState.state} loadingStates={[`${RECONCILIATION_RESUBMIT_LOADING_STATES.VIEW_PDF_LOADING}-${row?.FormRecordId}`]} messageMap={RECONCILIATION_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'View PDF'} onClickCb={() => dispatch(viewReconciliationPDF({ reconFormId: row?.FormRecordId, reconState: row?.State, formName: row?.ReconciliationFormName }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                </Loadable>
            </div>
        },
    ];

    return (
        <>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable currentState={loadingState.state} loadingStates={[RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]} messageMap={RECONCILIATION_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                        <SelectDropdown
                            name="selectedPayer"
                            label="Payer"
                            placeHolder="Select Payer"
                            options={payerList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayer(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedPayer}
                        />
                    </Loadable>
                </div>
            </div>

            {reconciliationResubmitGridData.length ? <div style={commonStyles.buttonContainer}>
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={commonStyles.button} onClickCb={() => {
                    if (selectedReconciliationResubmitGridData.length) {
                        dispatch(resubmitRecon({ selectedForms: selectedReconciliationResubmitGridData, payerId: selectedPayer?.value, paginationState }))
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                    }
                }} disabled={loadingState.state === RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING}>Submit</Button>
            </div> : null}

            <div>
                <Loadable currentState={loadingState.state} loadingStates={[RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]} messageMap={RECONCILIATION_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false} >
                    <RichGrid
                        selectable={true}
                        data={reconciliationResubmitGridData}
                        columns={RECONCILIATION_RESUBMIT_FORMS_COLUMN}
                        extractRowKey={(row) => row.FormId}
                        selectedRows={selectedReconciliationResubmitGridData}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedReconciliationResubmitGridData(selectedData))}
                        paginationProps={{
                            skip: paginationState?.Skip,
                            take: paginationState?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState?.total,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}
                    />
                </Loadable>
            </div>
            { isReconciliationFormSubmitPopupOpen && <ReconciliationFormSubmitPopup
                    isPopupOpen={isReconciliationFormSubmitPopupOpen}
                    title={`Form ${selectedRowForReconciliation?.ReconFormType}`}
                    formId={selectedRowForReconciliation?.ReconFormType}
                    handlePopupClose={() => setIsReconciliationFormSubmitPopupOpen(false)}
                    onFinalSubmitCb={() => dispatch(getReconciliationResubmitGridData({ payerId: selectedPayer?.value, ...paginationState }))}
                    isEditModeOn={(selectedRowForReconciliation?.FormRecordId && selectedRowForReconciliation?.FormRecordId != "0") ? true : false}
                    taxYear={selectedRowForReconciliation?.TaxYear}
                    reconciliationPayerId={selectedPayer?.value}
                    reconciliationState={selectedRowForReconciliation?.State}
                    formRecordId={(selectedRowForReconciliation?.FormRecordId && selectedRowForReconciliation?.FormRecordId != "0") ? selectedRowForReconciliation?.FormRecordId : 0}
                    referenceId={selectedRowForReconciliation?.ReferenceNumber}
                    quarter={selectedStateWitheldPaymentFrequency}
                />
            }
            {showStateWitheldPaymentFrequencyPopup && <Popup
                    title={FREQUENCY_POPUP_HEADER}
                    showClose={false}
                    isPopupOpen={showStateWitheldPaymentFrequencyPopup}
                >
                    <div style={commonStyles.frequencyPopupBody}>
                        <div style={commonStyles.frequencyPopupPaddingTen}>
                            {stateWitheldPaymentFrequency[selectedRowForReconciliation?.ReconFormType]?.map(frequency => 
                                    <RadioInput label={{  suffixLabel: frequency.label }} value={frequency.id} checked={ selectedStateWitheldPaymentFrequency === frequency.id } onChangeCb={(e) => dispatch(setSelectedStateWitheldPaymentFrequency(frequency.id))} />
                                )
                            }
                        </div>
                        <div style={commonStyles.frequencyPopupFooter}>
                            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => {
                                if(selectedStateWitheldPaymentFrequency !== "") {
                                    setIsReconciliationFormSubmitPopupOpen(true);
                                    dispatch(setShowStateWitheldPaymentFrequencyPopup(false))
                                } else {
                                    dispatch(addNotifications({
                                        heading: "Error",
                                        message: SELECT_PAYMENT_FREQUENCY,
                                        variant: TOASTER_VARIANT.WARNING,
                                    }))
                                }
                                }}>Confirm</Button>
                            <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
                                dispatch(setSelectedStateWitheldPaymentFrequency(""));
                                dispatch(setShowStateWitheldPaymentFrequencyPopup(false));
                                }} >Cancel</Button>
                        </div>
                    </div>
                </Popup>
            }
        </>
    )
}